export type UpdateOrgIdHandler = (id: string) => void;

export class WhiteboardOrgDataService {
	handlers: Set<UpdateOrgIdHandler> = new Set();
	private id: string | undefined = undefined;

	dispose() {
		this.handlers.clear();
	}

	updateOrgId(id: string) {
		this.id = id;
		this.handlers.forEach((handler) => handler(id));
	}

	onOrgIdChange(cb: UpdateOrgIdHandler) {
		this.handlers.add(cb);

		return () => {
			this.handlers.delete(cb);
		};
	}

	getId() {
		return this.id;
	}
}
